import { SettingsManager } from "@viamap/viamap2-common";
import { EjendomTingbog } from "./DLLTypes";

export class tinglysningCollector {

   static async EjendomTingbog(BFENummer: string): Promise<EjendomTingbog> {
      const body = {
         "BFEnr": BFENummer
      }
      return fetchTL("getTinglysningsData", body);
   }

   static async DokumentTingbog(uuid: string): Promise<XMLDocument> {
      const body = {
         "uuid": uuid
      }
      let reps = await fetchTL("getTinglysningsDokument", body);
      try {
         let parser = new DOMParser();
         let xmlNoTags = removeXmlNsPrefix(reps);
         return parser.parseFromString(xmlNoTags, "application/xml");
      } catch (error: Error | any) {
         console.error("Error parsing XML:", error?.message ?? error);
         throw new Error("Expected XML response");
      }
   }

   static async fetchServitutBilag(bilagRef: string): Promise<{ data: Blob, name: string } | undefined> {
      const body = {
         "BilagDokumentId": bilagRef
      }
      return await fetchEtlService("getTinglysningsBilag", body).then((response) => {
         if (!response.ok) {
            throw new Error("Network response was not ok");
         }
         return response.json();
      }).then((body) => {
         if (body && body.body) {
            console.log("Received bilag response:", body);
            let xmlText = JSON.parse(body.body);
            let removedNsXml = removeXmlNsPrefix(xmlText);
            let xml = new DOMParser().parseFromString(removedNsXml, "application/xml");
            let name = xml.getElementsByTagName("Titel")[0]?.textContent || "bilag";
            let data = xml.getElementsByTagName("AttachmentBinaryData")[0];
            console.log(xml);
            let mime = data?.getAttribute("mimetypeCode") || "application/pdf";
            console.log("Extracted bilag data - Name:", name, "MIME type:", mime);
            let base64Data = data?.textContent || "";
            console.log("Base64 data length:", base64Data.length);
            let blob = new Blob([Uint8Array.from(atob(base64Data), c => c.charCodeAt(0))], { type: mime });
            return { data: blob, name: name + "." + mime.split("/").at(-1) };
         }
      }).catch((error) => {
         console.error("Error fetching bilag:", error);
         throw new Error("Error fetching bilag");
      });
   }
}

async function fetchEtlService(endpoint: string, body: any): Promise<Response> {
   const baseUrl = SettingsManager.getSystemSetting("eTLServicesUrl");
   const url = baseUrl + "/" + endpoint;
   const API_KEY = SettingsManager.getSystemSetting("eTLServicesKey");

   return await fetch(url, {
      method: "POST",
      headers: {
         "x-api-key": API_KEY
      },
      body: JSON.stringify(body)
   })


}

async function fetchTL(endpoint: string, body: any): Promise<any> {
   const baseUrl = SettingsManager.getSystemSetting("dllServicesUrl");
   const url = "https://" + baseUrl + "/" + endpoint;
   const API_KEY = SettingsManager.getSystemSetting("dllServicesKey");

   return await fetch(url, {
      method: "POST",
      headers: {
         "x-api-key": API_KEY ? API_KEY : "",
         "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
   }).then((response) => {
      if (!response.ok) {
         throw new Error("Network response was not ok");
      }
      if (response.headers.get("Content-Type")?.includes("application/json")) {
         return response.json();
      }
      return response.text();
   });
}

function removeXmlNsPrefix(xmlString: string): string {
   return xmlString
      .replace(/(<\/?)(\S*?:)?/g, '$1')
}
